import axios from "../utils/axios";

// 🏢 Add Contact Us
export const createContactUs = async (contactUs) => {
  const response = await axios.post("/api/CustomRequest/Create", contactUs);
  //console.log(response);
  return response.data;
};